import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import campaignApi from "../../api/campaignApi";

/**
 * Nudge X2 hoàn tiền (web) — hiện dưới dòng "Hoàn tiền đến" trên màn Mua sắm hoàn tiền.
 * Khuyến khích user mua qua App để nhận x2. Ẩn khi đợt không active.
 * Khoảng ưu đãi lấy động từ startTime/endTime (BE) — KHÔNG hardcode ngày.
 * Status fetch 1 lần, cache module-level (nhiều card không refetch).
 */

// Cache module-level có TTL: dedupe trong phiên nhưng vẫn cập nhật qua mốc bật/tắt đợt.
const TTL_MS = 5 * 60 * 1000; // 5 phút
let _cache = null; // { ts, data }
let _inflight = null;
function fetchAppX2Status() {
    if (_cache && Date.now() - _cache.ts < TTL_MS) return Promise.resolve(_cache.data);
    if (_inflight) return _inflight;
    _inflight = campaignApi
        .getAppX2Status()
        .then((res) => {
            const data = res.data || { active: false, multiplier: 1 };
            _cache = { ts: Date.now(), data };
            _inflight = null;
            return data;
        })
        .catch(() => {
            _inflight = null; // lỗi → KHÔNG cache, lần mount sau thử lại
            return { active: false, multiplier: 1 };
        });
    return _inflight;
}

function AppX2CashbackNote() {
    const [status, setStatus] = useState({ active: false, multiplier: 1 });

    useEffect(() => {
        let mounted = true;
        fetchAppX2Status().then((s) => {
            if (mounted) setStatus(s);
        });
        return () => {
            mounted = false;
        };
    }, []);

    if (!status.active) return null;

    const mult = Number(status.multiplier) > 1 ? Number(status.multiplier) : 2;
    // Khoảng ưu đãi hiện theo startTime/endTime BE trả (D/M HhMM, giờ máy).
    const start = formatDateTime(status.startTime);
    const end = formatDateTime(status.endTime);
    const period = start && end ? `từ ${start} đến ${end}` : end ? `đến hết ${end}` : "";

    return (
        <div className="mt-1.5 flex flex-wrap items-center gap-2 rounded-lg bg-amber-50 border border-amber-200 px-2.5 py-1.5">
            <span className="text-xs font-semibold text-amber-700">{buildNudgeText(status, mult, period)}</span>
            <Link
                to="/tai-app"
                className="text-xs font-bold text-white bg-gradient-to-r from-brand-red to-brand-warm rounded-full px-3 py-1 active:scale-95 transition-all"
            >
                📱 Tải App
            </Link>
        </div>
    );
}

/**
 * Chữ nudge: ưu tiên câu admin tự viết cho đợt (config nudgeText của Chương trình
 * thưởng — thay {x} = hệ số, {period} = khoảng thời gian), để trống thì tự sinh.
 * Đợt đang hiện SỚM (nudgeLeadDays) → đổi thành "sắp có" cho khỏi hiểu nhầm.
 * Giữ nguyên CTA "Tải App" vì hệ số chỉ áp cho đơn mua trên App.
 */
function buildNudgeText(status, mult, period) {
    const custom = String(status.nudgeText || "").trim();
    if (custom) {
        return custom.replace(/\{x\}/g, String(mult)).replace(/\{period\}/g, period);
    }
    const periodPart = period ? ` (${period})` : "";
    if (status.upcoming) {
        return `🔥 Sắp có đợt x${mult} hoàn tiền cho đơn mua trên App Longhousee${periodPart}!`;
    }
    return `🔥 Mua trên App Longhousee để nhận x${mult} hoàn tiền${periodPart}!`;
}

/** Unix giây → "D/M HhMM" (vd 07/07 23:59 → "7/7 23h59"). Null/không hợp lệ → "". */
function formatDateTime(unixSec) {
    const t = Number(unixSec);
    if (!Number.isFinite(t) || t <= 0) return "";
    const d = new Date(t * 1000);
    const mm = String(d.getMinutes()).padStart(2, "0");
    return `${d.getDate()}/${d.getMonth() + 1} ${d.getHours()}h${mm}`;
}

export default AppX2CashbackNote;
